import constants from './constants';

const LOCATIONS = [
  ...constants.LOCATIONS,
  'Asia',
  'Africa',
  'North America',
  'Australia',
  'United States',
  'Argentina',
  'South America',
  'Europe',
  'Algeria',
  'Atlanta Metropolitan Area',
  'Brazil',
  'Bangladesh',
  'Belgium',
  'Bengaluru, Karnataka, India',
  'United Kingdom',
  'Beijing, China',
  'Bogotá D.C. Metropolitan Area',
  'São Paulo, Brazil',
  'China',
  'Canada',
  'Colombia',
  'California, United States',
  'Chile',
  'Chennai, Tamil Nadu, India',
  'Czechia',
  'New York City Metropolitan Area',
  'Cook County, Illinois, United States',
  'Delhi, India',
  'Dallas-Fort Worth Metroplex',
  'Denmark',
  'Detroit Metropolitan Area',
  'Denver Metropolitan Area',
  'Dominican Republic',
  'Greater Delhi Area',
  'England, United Kingdom',
  'Egypt',
  'Ecuador',
  'Indonesia',
  'Spain',
  'United Arab Emirates',
  'Ethiopia',
  'France',
  'Florida, United States',
  'Finland',
  'Fujian, China',
  'Philippines',
  'San Francisco Bay Area',
  'Fulton County, Georgia, United States',
  'Frankfurt Rhine-Main Metropolitan Area',
  'Germany',
  'India',
  'Greater São Paulo Area',
  'Greater Paris Metropolitan Region',
  'Hong Kong SAR',
  'Hyderabad, Telangana, India',
  'Haryana, India',
  'Harris County, Texas, United States',
  'Hungary',
  'Henan, China',
  'Houston, Texas, United States',
  'Hangzhou-Shaoxing Metropolitan Area',
  'Italy',
  'Iran',
  'Illinois, United States',
  'Ireland',
  'Israel',
  'Iraq',
  'Jakarta Metropolitan Area',
  'Japan',
  'Jiangsu, China',
  'Johannesburg Metropolitan Area',
  'Jordan',
  'South Africa',
  'Karnataka, India',
  'Kenya',
  'Kerala, India',
  'Kazakhstan',
  'Kansas, United States',
  'Los Angeles Metropolitan Area',
  'London Area, United Kingdom',
  'Mexico',
  'Maharashtra, India',
  'Malaysia',
  'Mumbai Metropolitan Region',
  'Morocco',
  'Mumbai, Maharashtra, India',
  'Miami-Fort Lauderdale Area',
  'Minas Gerais, Brazil',
  'Michigan, United States',
  'Netherlands',
  'Nigeria',
  'New York, United States',
  'New Delhi, Delhi, India',
  'New York, New York, United States',
  'New Zealand',
  'Norway',
  'Ontario, Canada',
  'Greater Ottawa Metropolitan Area',
  'Ottawa, Ontario, Canada',
  'Ohio, United States',
  'Oregon, United States',
  'Orange County, California, United States',
  'Occitanie, France',
  'Oman',
  'Oklahoma, United States',
  'Pakistan',
  'Peru',
  'Poland',
  'Portugal',
  'Pennsylvania, United States',
  'Pune/Pimpri-Chinchwad Area',
  'Pune, Maharashtra, India',
  'Quebec, Canada',
  'Queensland, Australia',
  'Qatar',
  'Queens, New York, United States',
  'Queens County, New York, United States',
  'Queretaro Metropolitan Area',
  'Qingdao, Shandong, China',
  'Querétaro, Mexico',
  'Russia',
  'Romania',
  'Rio de Janeiro, Brazil',
  'Rajasthan, India',
  'Rio Grande do Sul, Brazil',
  'Rio de Janeiro, Rio de Janeiro, Brazil',
  'Raleigh-Durham-Chapel Hill Area',
  'Saudi Arabia',
  'Sweden',
  'Switzerland',
  'Turkey',
  'Texas, United States',
  'Tamil Nadu, India',
  'Thailand',
  'Taiwan',
  'Telangana, India',
  'Tunisia',
  'Tennessee, United States',
  'Toronto, Ontario, Canada',
  'Ukraine',
  'Vietnam',
  'Venezuela',
  'Virginia, United States',
  'Victoria, Australia',
  'Washington DC-Baltimore Area',
  'Washington, United States',
  'West Bengal, India',
  'Wisconsin, United States',
  'Washim, Maharashtra, India',
  'Warsaw Metropolitan Area',
  "Xi'an Metropolitan Area",
  "Xi'an, Shaanxi, China",
  'Xiamen-Zhangzhou Metropolitan Area',
  'Xicheng District, Beijing, China',
  'Xinjiang Uygur, China',
  'Xiamen, Fujian, China',
  'Shanghai, China',
  'Xuhui District, Shanghai, China',
  'Xuzhou, Jiangsu, China',
  'Xalapa Metropolitan Area',
  'Yunnan, China',
  'Yemen',
  'York, Ontario, Canada',
  'Zhejiang, China',
  'Zimbabwe',
  'Zambia',
  'Zhengzhou-Kaifeng Metropolitan Area',
  'Québec, Quebec, Canada',
  'Montreal, Quebec, Canada',
  'Capitale-Nationale, Quebec, Canada',
  'Longueuil, Quebec, Canada',
  'Laval, Quebec, Canada',
  'Gatineau, Quebec, Canada',
  'Sherbrooke, Quebec, Canada',
  'Roussillon Regional County Municipality, Quebec, Canada',
  'Thérèse-De Blainville Regional County Municipality, Quebec, Canada',
  'Brisbane, Queensland, Australia',
  'Brisbane City, Queensland, Australia',
  'Gold Coast, Queensland, Australia',
  'Sunshine Coast, Queensland, Australia',
  'Townsville, Queensland, Australia',
  'Cairns, Queensland, Australia',
  'Toowoomba, Queensland, Australia',
  'Westbrook, Queensland, Australia',
  'Mooroobool, Queensland, Australia',
  'Querétaro, Querétaro, Mexico',
  'El Marqués, Querétaro, Mexico',
  'San Juan del Río, Querétaro, Mexico',
  'Corregidora, Querétaro, Mexico',
  'Corregidora Municipality, Querétaro, Mexico',
  'La Cañada, Querétaro, Mexico',
  'Tequisquiapan, Querétaro, Mexico',
  'Tolimán Municipality, Querétaro, Mexico',
  'Tolimán, Querétaro, Mexico',
  'Duque de Caxias, Rio de Janeiro, Brazil',
  'São Gonçalo, Rio de Janeiro, Brazil',
  'Niterói, Rio de Janeiro, Brazil',
  'Nova Iguaçu, Rio de Janeiro, Brazil',
  'Campos dos Goytacazes, Rio de Janeiro, Brazil',
  'Macaé, Rio de Janeiro, Brazil',
  'São João de Meriti, Rio de Janeiro, Brazil',
  'Volta Redonda, Rio de Janeiro, Brazil',
  'London, England, United Kingdom',
  'Scotland, United Kingdom',
  'Manchester Area, United Kingdom',
  'Greater Manchester, England, United Kingdom',
  'West Midlands, England, United Kingdom',
  'Wales, United Kingdom',
  'West Yorkshire, England, United Kingdom',
  'Los Angeles County, California, United States',
  'Georgia, United States',
  'New South Wales, Australia',
  'Sydney, New South Wales, Australia',
  'Melbourne, Victoria, Australia',
  'Australian Capital Territory, Australia',
  'Western Australia, Australia',
  'Perth, Western Australia, Australia',
  'Cordoba, Argentina Metropolitan Area',
  'American River, South Australia, Australia',
  'American Beach, South Australia, Australia',
  'São Paulo, São Paulo, Brazil',
  'Paraná, Brazil',
  'Bahia, Brazil',
  'Santa Catarina, Brazil',
  'Guangdong, China',
  'Shandong, China',
  'Chengdu, Sichuan, China',
  'Sichuan, China',
  'Greater Toronto Area, Canada',
  'British Columbia, Canada',
  'Alberta, Canada',
  'Greater Vancouver, British Columbia, Canada',
  'Calgary, Alberta, Canada',
  'Santiago Metropolitan Region, Chile',
  'Provincia de Santiago, Santiago Metropolitan Region, Chile',
  'Santiago, Santiago Metropolitan Region, Chile',
  'Île-de-France, France',
  'Paris, Île-de-France, France',
  'Auvergne-Rhône-Alpes, France',
  "Provence-Alpes-Côte d'Azur, France",
  'Nouvelle-Aquitaine, France',
  'Hauts-de-France, France',
  'Grand Est, France',
  'Pays de la Loire, France',
  'North Rhine-Westphalia, Germany',
  'Bavaria, Germany',
  'Baden-Württemberg, Germany',
  'Hesse, Germany',
  'Berlin, Germany',
  'Stadt Berlin, Berlin, Germany',
  'Berlin, Berlin, Germany',
  'Lower Saxony, Germany',
  'Munich, Bavaria, Germany',
  'Indiana, United States',
  'Uttar Pradesh, India',
  'Northern Ireland, United Kingdom',
  'Belfast City, Northern Ireland, United Kingdom',
  'Belfast, Northern Ireland, United Kingdom',
  'Tokyo, Japan',
  'Tokyo, Tokyo, Japan',
  'Kanagawa, Japan',
  'Osaka, Japan',
  'Chiba, Japan',
  'Yokohama, Kanagawa, Japan',
  'Saitama, Japan',
  'Osaka, Osaka, Japan',
  'Aichi, Japan',
  'Jordan, Minnesota, United States',
  'Jordan Station, Ontario, Canada',
  'West Jordan, Utah, United States',
  'Jordan, New York, United States',
  'South Jordan, Utah, United States',
  'Los Angeles metropolitan area, California, United States',
  'México, Mexico',
  'Mexico City, Mexico',
  'Mexico City Metropolitan Area',
  'Guadalajara, Mexico Metropolitan Area',
  'Jalisco, Mexico',
  'Nuevo León, Mexico',
  'Mexicali, Baja California, Mexico',
  'New Mexico, United States',
  'Veracruz, Mexico',
  'Peru, Indiana, United States',
  'Peru, Illinois, United States',
  'Mazowieckie, Poland',
  'Warsaw, Mazowieckie, Poland',
  'Małopolskie, Poland',
  'Śląskie, Poland',
  'Dolnośląskie, Poland',
  'Pomorskie, Poland',
  'Wielkopolskie, Poland',
  'Cracow, Małopolskie, Poland',
  'Poznań, Wielkopolskie, Poland',
  'Ciudad Guayana, Venezuela Metropolitan Area',
  'Serbia',
  'Afghanistan',
  'Albania',
  'American Samoa',
  'Andorra',
  'Angola',
  'Angola, Indiana, United States',
  'Angola, New York, United States',
  'Anguilla',
  'Anguilla, Mississippi, United States',
  'Antarctica',
  'Antigua and Barbuda',
  'Armenia',
  'Armenia Metropolitan Area',
  'Aruba',
  'Austria',
  'Azerbaijan',
  'The Bahamas',
  'Bahrain',
  'Barbados',
  'Belarus',
  'Belize',
  'Benin',
  'Bermuda',
  'Bermuda, Virginia, United States',
  'Bermuda Park, England, United Kingdom',
  'Bermuda Dunes, California, United States',
  'Bermuda Industrial Estate, England, United Kingdom',
  'Bhutan',
  'Bolivia',
  'Bolivia, North Carolina, United States',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chadoora, Jammu & Kashmir, India',
  'Chadderton, England, United Kingdom',
  'Chadstone, Victoria, Australia',
  'Chadds Ford, Pennsylvania, United States',
  'Chadron, Nebraska, United States',
  'Chadbourn, North Carolina, United States',
  'Christmas Island',
  'Christmas Island, Nova Scotia, Canada',
  'Cocos (Keeling) Islands',
  'Comoros',
  'Congo (DRC)',
  'Republic of the Congo',
  'Congonhas, Minas Gerais, Brazil',
  'Cook Islands',
  'Costa Rica',
  'Costa Rica, Mato Grosso do Sul, Brazil',
  'Côte d’Ivoire',
  'Croatia',
  'Cuba',
  'Cubatão, São Paulo, Brazil',
  'Cuba, Missouri, United States',
  'Cuba, New York, United States',
  'Cuba, New Mexico, United States',
  'Cuba, Illinois, United States',
  'Cyprus',
  'Djibouti',
  'Dominica',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'French Guiana',
  'French Polynesia',
  'Gabon',
  'The Gambia',
  'Georgia',
  'Atlanta, Georgia, United States',
  'Gwinnett County, Georgia, United States',
  'Cobb County, Georgia, United States',
  'DeKalb County, Georgia, United States',
  'Marietta, Georgia, United States',
  'Alpharetta, Georgia, United States',
  'Chatham County, Georgia, United States',
  'Ghana',
  'Gibraltar',
  'Gibraltar, England, United Kingdom',
  'Gibraltar, Wisconsin, United States',
  'Gibraltar Range, New South Wales, Australia',
  'Greece',
  'Greenland',
  'Greenland, New Hampshire, United States',
  'Greenland, Michigan, United States',
  'Grenada',
  'Grenada, Mississippi, United States',
  'Grenada County, Mississippi, United States',
  'Grenada, California, United States',
  'French-Guadeloupe',
  'Guam',
  'Guamúchil, Sinaloa, Mexico',
  'Guamaré, Rio Grande do Norte, Brazil',
  'Guatemala',
  'Guinea',
  'Papua New Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Iceland',
  'Jamaica',
  'Jamaica, New York, United States',
  'Jamaica, Vermont, United States',
  'Kiribati',
  'North Korea',
  'North Gyeongsang, South Korea',
  'North Jeolla, South Korea',
  'North Chungcheong, South Korea',
  'Pohang, North Gyeongsang, South Korea',
  'Gunsan, North Jeolla, South Korea',
  'South Korea',
  'Seoul, South Korea',
  'Seoul, Seoul, South Korea',
  'Gyeonggi, South Korea',
  'South Gyeongsang, South Korea',
  'Gangnam District, Seoul, South Korea',
  'South Chungcheong, South Korea',
  'Incheon, South Korea',
  'Busan, South Korea',
  'Saemkkumi, Gyeonggi, South Korea',
  'Kuwait',
  'Kuwait City Metropolitan Area',
  'Kyrgyzstan',
  'Laos',
  'Laoshan District, Shandong, China',
  'Latvia',
  'Lebanon',
  'Lebanon, Tennessee, United States',
  'Lebanon, Pennsylvania, United States',
  'Lebanon, Ohio, United States',
  'Lebanon County, Pennsylvania, United States',
  'Lebanon, Indiana, United States',
  'Lebanon, Oregon, United States',
  'Lebanon, New Hampshire, United States',
  'Lebanon, Missouri, United States',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao SAR',
  'Macau, Rio Grande do Norte, Brazil',
  'Macau, Nouvelle-Aquitaine, France',
  'Macaubal, São Paulo, Brazil',
  'Macaúbas, Bahia, Brazil',
  'Brotas de Macaúbas, Bahia, Brazil',
  'North Macedonia',
  'Macedonia, Ohio, United States',
  'Madagascar',
  'Malawi',
  'Maldives',
  'Mali',
  'Maliya, Gujarat, India',
  'Malihabad, Uttar Pradesh, India',
  'Malibu, California, United States',
  'Malia, Gujarat, India',
  'Malipo, Yunnan, China',
  'Malta',
  'Malta, Illinois, United States',
  'Malta, Montana, United States',
  'Malta, Ohio, United States',
  'Malta, Paraíba, Brazil',
  'Malta, Idaho, United States',
  'Malta, New York, United States',
  'Marshall Islands',
  'French-Martinique',
  'Fort-de-France, French-Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Federated States of Micronesia',
  'Moldova',
  'Monaco',
  'Greater Munich Metropolitan Area',
  'Mongolia',
  'Inner Mongolia, China',
  'Hohhot, Inner Mongolia, China',
  'Baotou, Inner Mongolia, China',
  'Chifeng, Inner Mongolia, China',
  'Tongliao, Inner Mongolia, China',
  'Morin Dawa, Inner Mongolia, China',
  'Manzhouli, Inner Mongolia, China',
  'Montserrat',
  'Montserrat, Missouri, United States',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'New Caledonia',
  'Caledonia, New York, United States',
  'Nicaragua',
  'Chinandega, Nicaragua',
  'Niger',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Palau',
  'Palau-del-Vidre, Occitanie, France',
  'Palau, Coahuila, Mexico',
  'Palau-de-Cerdagne, Occitanie, France',
  'Panama',
  'Panama City, Florida, United States',
  'Greater Panama City Area',
  'Panama City Beach, Florida, United States',
  'Paraguay',
  'Pitcairn Islands',
  'Pitcairn, Pennsylvania, United States',
  'Pitcairngreen, Scotland, United Kingdom',
  'Pitcairn, New York, United States',
  'Pitcairnfield, Scotland, United Kingdom',
  'Puerto Rico',
  'Reunion',
  'Rwanda',
  'St Kitts and Nevis',
  'Saint Lucia',
  'St. Lucie County, Florida, United States',
  'St Lucia, Queensland, Australia',
  'St Vincent and the Grenadines',
  'Samoa',
  'Samoa, California, United States',
  'San Marino',
  'San Marino, California, United States',
  'São Tomé and Príncipe',
  'São Tomé, Paraná, Brazil',
  'São Tomé, Rio Grande do Norte, Brazil',
  'São Tomé das Letras, Minas Gerais, Brazil',
  'Senegal',
  'Seychelles',
  'Sierra Leone',
  'Western Area Rural District, Western, Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'Colombo, Western Province, Sri Lanka',
  'Colombo District, Western Province, Sri Lanka',
  'Sri Lanka',
  'St. Helena Parish County, Louisiana, United States',
  'St Helena, California, United States',
  'St Helena, Nebraska, United States',
  'Saint Pierre and Miquelon',
  'Saint-Pierre-des-Corps, Centre-Val de Loire, France',
  'Saint-Pierre-d’Oléron, Nouvelle-Aquitaine, France',
  'Havre-Saint-Pierre, Quebec, Canada',
  'Saint-Pierre-lès-Elbeuf, Normandy, France',
  'St-Pierre-Jolys, Manitoba, Canada',
  'Sudan',
  'South Sudan',
  'Sudan, Texas, United States',
  'Suriname',
  'Tajikistan',
  'Tanzania',
  'Togo',
  'Togo, Aichi, Japan',
  'Togo, Saskatchewan, Canada',
  'Tokelau',
  'Tonga',
  'Tonganoxie, Kansas, United States',
  'Tongan District, Fujian, China',
  'Trinidad and Tobago',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'British Virgin Islands',
];

export default LOCATIONS;
